module.exports = __webpack_public_path__ + "img/accessory_item_16.cc10967b.svg";